import React, { useState } from "react";
import styled from "styled-components";
import SpecialLifeAtButton from "@common/LifeAtButton/Variants/SpecialLifeAtButton";
import LifeAtModal from "@common/LifeAtModal/LifeAtModal";
import { ScrollbarStyles } from "@themes/ScrollbarStyles";
import Styles from "@themes/Styles";

const ScreenShareModal = styled(LifeAtModal)`
    .lifeat-modal {
        max-height: 80%;

        .modal-content {
            height: 100%;
            overflow-y: scroll;

            > * {
                margin-bottom: unset;
            }
        }
    }
`;
const ModalContent = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow-y: scroll;
`;
const SelectorElement = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

    padding: 20px;
`;
const SourcesContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);

    overflow-y: scroll;
    ${ScrollbarStyles};
    scrollbar-gutter: stable both-edges;
`;
const ThumbnailImage = styled.img<{ selected: boolean }>`
    height: 100px;
    width: auto;
    margin-bottom: 5px;

    outline: ${(props) => (props.selected ? `2px solid ${Styles.buttonFillBlue}` : ``)};
`;
const ModalFooter = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 5px;
`;
const ShareButton = styled(SpecialLifeAtButton)`
    width: fit-content;
    padding: 6px 10px;
    .lifeat-button-text {
        padding-left: unset !important;
    }
`;

interface RoomScreenShareSelectorModalProps {
    readonly isOpen: boolean;
    readonly onClose: () => void;
    readonly screenShareSources: Electron.DesktopCapturerSource[];
    readonly onSelect: (selectedSource: Electron.DesktopCapturerSource) => void;
}
function RoomScreenShareSelectorModal(props: RoomScreenShareSelectorModalProps) {
    const [currentSelectedSource, setCurrentSelectedSource] = useState<Electron.DesktopCapturerSource>();

    const handleClickSharScreenButton = () => {
        if (currentSelectedSource) {
            props.onSelect(currentSelectedSource);
            props.onClose();
        }
    };

    return (
        <ScreenShareModal
            key={`room-screen-share-modal`}
            title={"Choose what to share"}
            isOpen={props.isOpen}
            closeModal={props.onClose}
        >
            <ModalContent>
                <SourcesContainer>
                    {props.screenShareSources.map((source: Electron.DesktopCapturerSource) => {
                        return (
                            <SelectorElement
                                onClick={() => setCurrentSelectedSource(source)}
                                key={`screen-share-source-${source.id}`}
                            >
                                <ThumbnailImage
                                    src={source.thumbnail as any}
                                    selected={currentSelectedSource?.id === source.id}
                                />
                                {source.name.length < 30 ? source.name : `${source.name.substring(0, 26)}...`}
                            </SelectorElement>
                        );
                    })}
                </SourcesContainer>

                <ModalFooter>
                    <ShareButton
                        isLink={false}
                        text={"Share"}
                        handleClick={handleClickSharScreenButton}
                        size={"small"}
                        variant={"red"}
                        iconRight={false}
                        disabled={currentSelectedSource === undefined}
                    />
                </ModalFooter>
            </ModalContent>
        </ScreenShareModal>
    );
}

export default RoomScreenShareSelectorModal;
